<script>
export default {
  name: 'BriqRequiredAndOptionalMarkers',
  functional: true,
  render(h, { props }) {
    const showOptional = !props.hideOptionalMarker && props.label && !props.isRequired
    const showRequired = props.isRequired && props.label
    if (!showOptional && !showRequired) return null
    return h(
      'span',
      {
        class: {
          'optional-marker': showOptional,
          'required-marker': showRequired,
          'type-bold': showRequired,
        },
      },
      showOptional ? 'Optional' : '*',
    )
  },
}
</script>
